import { remindersGet, remindersPost, remindersPut } from "./remindersHttp";

export function fetchAdminMessagesActive() {
  return remindersGet("/admin-messages/active");
}

export function fetchAdminMessagesFeed() {
  return remindersGet("/admin-messages");
}

export function createAdminMessage(payload) {
  return remindersPost("/admin-messages", payload);
}

export function updateAdminMessage(id, payload) {
  return remindersPut(`/admin-messages/${id}`, payload);
}

export function ackAdminMessage(id) {
  return remindersPost(`/admin-messages/${id}/ack`, {});
}

export function dismissAdminMessage(id) {
  return remindersPost(`/admin-messages/${id}/dismiss`, {});
}

export function seenAdminMessage(id) {
  return remindersPost(`/admin-messages/${id}/seen`, {});
}

export function fetchAdminMessageReadReport(id) {
  return remindersGet(`/admin-messages/${id}/read-report`);
}
